import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=2e6fb2aa&scoped=true"
var script = {}
import style0 from "./Contacts.vue?vue&type=style&index=0&id=2e6fb2aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6fb2aa",
  null
  
)

export default component.exports